// src/components/MachineList.jsx
import React, {useContext} from "react";
import {AppContext} from "../context/AppContext";
import {useOverviewData} from "../hooks/useOverviewData";
import MachineRow from "./MachineRow";

function MachineList() {
  const {selectedDate} = useContext(AppContext);
  const {machines, loading} = useOverviewData(selectedDate);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <main>
      <div id="machine-status-container">
        {machines.map((machine, index) => (
          <MachineRow key={machine.serialNumber || index} machine={machine} />
        ))}
      </div>
    </main>
  );
}

export default MachineList;
